import React from 'react';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ["You end every month not knowing if next month's income will cover your bills", 'Clients drop off after 4–6 weeks and you have no system to stop it happening', "You're losing NZD $300–$500 every single month in cancellations you can't prevent", 'A potential client sits in front of you and you freeze — no script, no close, and they walk away', "You're watching less-qualified trainers charge double your rate because they look more professional", "Your onboarding is so inconsistent that clients don't trust the process — and they leave before they see results", 'You have no follow-up system, so dead leads stay dead and your pipeline stays empty', "You've been charging the same rate for 2 years because you don't know how to justify a price increase", "Every week you think about whether you'll have to go back to a 9-to-5 to pay your bills", "The worst part? You know you're a good coach. But good coaching alone doesn't pay the rent."];
  return <section className="bg-pain py-12 md:py-20 border-y border-red-900/30" data-id="element-190">
      <div className="max-w-4xl mx-auto px-4" data-id="element-191">
        <div className="text-center mb-10" data-id="element-192">
          <h2 className="text-white text-2xl md:text-4xl font-bold font-playfair mb-4" data-id="element-193">
            Here's the truth nobody tells you when you get your PT
            certification:
          </h2>
          <h3 className="text-soft-gold text-xl md:text-2xl font-bold" data-id="element-194">
            Being a great trainer is not enough to build a real income.
          </h3>
        </div>

        <div className="space-y-6 mb-10" data-id="element-195">
          <p className="text-white text-base md:text-lg leading-relaxed" data-id="element-196">
            You trained hard to get certified. You genuinely love coaching
            people. But every month feels like starting from zero.
          </p>
          <p className="text-white text-base md:text-lg leading-relaxed" data-id="element-197">
            And deep down, a voice keeps getting louder:
          </p>
        </div>

        <div className="bg-[#2A0000] border-l-4 border-soft-gold p-6 md:p-8 rounded-r-xl mb-10 shadow-lg" data-id="element-198">
          <p className="text-soft-gold italic text-lg md:text-xl font-playfair" data-id="element-199">
            "Is this actually sustainable? Can I really make a living doing
            this? Or am I going to have to give up and go back to a job I hate?"
          </p>
        </div>

        <p className="text-soft-gold text-base md:text-xl font-bold text-center mb-10" data-id="element-200">
          That fear is real. And it's not your fault.
        </p>

        <div className="bg-[#0F0000] border border-red-900/50 rounded-xl p-6 md:p-8 mb-12 shadow-2xl" data-id="element-201">
          <div className="space-y-4" data-id="element-202">
            {painPoints.map((point, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-203">
                <AlertCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-204" />
                <p className="text-white/90 text-sm md:text-base" data-id="element-205">{point}</p>
              </div>)}
          </div>
        </div>

        <div className="bg-soft-gold text-black p-6 md:p-8 rounded-xl shadow-[0_0_30px_rgba(212,175,55,0.2)]" data-id="element-206">
          <p className="text-lg md:text-xl font-bold text-center" data-id="element-207">
            What if the only thing standing between you and a full-time PT
            income... was a system you just didn't have yet?
          </p>
        </div>
      </div>
    </section>;
}